import React from 'react';
import PropTypes from 'prop-types';

import InputMask from 'react-input-mask';
import { integer, decimal, currency, date } from './masks';

const Language = window.Realize.i18n;

export default class InputFilter extends React.Component {
	static propTypes = {
		field: PropTypes.object,
		filterClientSideTable: PropTypes.func
	}

	static defaultProps = {
		change: () => {},
		field: {},
		filterClientSideTable: () => {}
	}

	state = { }

	setCssInput() {
		return {
			border: '1px solid #ccc',
			borderRadius: '4px',
			fontSize:'14px',
			fontWeight: '400',
			padding: '5px'
		}
	}

	renderInput() {
		const labelPlaceholder = Language.t('template.actions.search');
		const { field } = this.props
		const { component, mask, prefix, digits } = field

		const configMask = {
			component,
			prefix,
			digits
		}

		if(!field) {
			return
		}

		if(mask) {
			return (
				<InputMask
					style={this.setCssInput()}
					onChange={event => this.onChangeInputFilter(event)}
					mask={mask}
					maskChar={null}
					placeholder={labelPlaceholder}
				/>
			)
		}

		return (
			<input
				style={this.setCssInput()}
				onChange={
					event => {
						this.applyMask(event, configMask)
						this.onChangeInputFilter(event)
					}
				}
				placeholder={labelPlaceholder}
			/>
		)
	}

	/**
	 * @description Verifica o tipo do componente e aplica a máscara.
	 * @param {Object} event Objeto com propriedades e métodos do DOM.
	 * @param {Object} config Objeto com configuração contendo o tipo da máscara.
	 * @param {String} config.component
	 * @returns {Object} Objeto event com o target.value formatado com a máscara.
	 */
	applyMask(event, config) {
		if(config.component === 'number') {
			return integer(event, config)
		}

		if(config.component === 'datepicker') {
			return date(event, config)
		}

		if(config.component === 'decimal'){
			return decimal(event, config)
		}

		if(config.component === 'currency') {
			return currency(event, config)
		}

		return event
	}

	/**
	 * @description Captura o value do input e retira a máscara caso seja necessário e envia via props para o componente pai.
	 * @param {Object} event Objeto com propriedades e métodos do DOM.
	 */
	onChangeInputFilter(event) {
		const {filterClientSideTable, name, field} = this.props
		const { component } = field
		const textSanitized = this.clearMask(event.target.value, component)
		filterClientSideTable(name, textSanitized)
	}

	/**
	 * @description Retira da string tudo que for diferente de números e ponto(.).
	 * @param {String} value String com ou sem máscara aplicada.
	 * @param {String} component String com componente, caso seja ('number', 'decimal', 'currency') é retirado a máscara.
	 * @returns String sem máscara.
	 */
	clearMask(value, component) {
		const languageLocale = Language.currentLocale;
		const typeComponent = ['number', 'decimal', 'currency'];
		if(typeComponent.includes(component) && value) {
			const valueWithoutMask = languageLocale === 'en'
			? value
				.match(/\d|\./g)
				.join('')
			: value
				.match(/\d|\.|,/g)
				.join('')
				.replace(/\./g, '')
				.replace(/,/g, '.')

			return valueWithoutMask;
		}
		return value;
	}

	render() {
		return (
			<div >
				{this.renderInput()}
			</div>
		)
	}
}
